const config = {
  facebook: {
    appId: '258690058065348',
    autoLogAppEvents: true,
    xfbml: true,
    version: 'v3.1',
  },
}

export default config



// WEBPACK FOOTER //
// ./src/config.js